/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-tag-spacing */
import React from 'react';
import PropTypes from 'prop-types';

const visuallyHidden = {
  position: 'absolute',
  height: 1,
  width: 1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap'
};

const Groupremove = ({ title, width, height, ...rest }) => (
  <>
    <svg
      aria-hidden="true"
      focusable="false"
      height={height}
      preserveAspectRatio="none"
      viewBox="0 0 24 24"
      width={width}
      {...rest}
    >
      <path transform="scale(1 1)" fillRule="evenodd" d="M8.68,7.18 C8.2399978,7.18 7.8266686,7.0666678 7.44,6.84 C7.0533314,6.6133322 6.7466678,6.3066686 6.52,5.92 C6.2933322,5.5333314 6.18,5.1200022 6.18,4.68 C6.18,4.2399978 6.2933322,3.8266686 6.52,3.44 C6.7466678,3.0533314 7.0533314,2.7466678 7.44,2.52 C7.8266686,2.2933322 8.2399978,2.18 8.68,2.18 C9.1200022,2.18 9.5299981,2.2933322 9.91,2.52 C10.2900019,2.7466678 10.5899989,3.0499981 10.81,3.43 C11.0300011,3.8100019 11.14,4.2266644 11.14,4.68 C11.14,5.1333356 11.0300011,5.5499981 10.81,5.93 C10.5899989,6.3100019 10.2900019,6.6133322 9.91,6.84 C9.5299981,7.0666678 9.1200022,7.18 8.68,7.18 Z M19.2426407,12.7573593 C21.5857864,15.1005051 21.5857864,18.8994949 19.2426407,21.2426407 C16.8994949,23.5857864 13.1005051,23.5857864 10.7573593,21.2426407 C8.41421356,18.8994949 8.41421356,15.1005051 10.7573593,12.7573593 C13.1005051,10.4142136 16.8994949,10.4142136 19.2426407,12.7573593 Z M8.68,8.82 C9.4000036,8.82 10.193329,8.9266656 11.06,9.14 C12.0333382,9.3933346 12.82,9.719998 13.42,10.12 L13.4846811,10.1650836 C12.2260533,10.4428783 11.0292371,11.071268 10.0502525,12.0502525 C7.94931593,14.1511891 7.46303455,17.2553439 8.59140839,19.8206889 L2.82,19.82 L2.82,11.74 C2.82,11.139997 3.1799964,10.6000024 3.9,10.12 C4.5133364,9.719998 5.3066618,9.3933346 6.28,9.14 C7.1600044,8.9266656 7.9599964,8.82 8.68,8.82 Z M18.25,16.25 L11.75,16.25 C11.3357864,16.25 11,16.5857864 11,17 C11,17.4142136 11.3357864,17.75 11.75,17.75 L18.25,17.75 C18.6642136,17.75 19,17.4142136 19,17 C19,16.5857864 18.6642136,16.25 18.25,16.25 Z M15.32,8.82 C16.04,8.82 16.8399956,8.9266656 17.72,9.14 C18.6933382,9.3933346 19.4866636,9.719998 20.1,10.12 C20.8200036,10.6000024 21.18,11.139997 21.18,11.74 L21.1798527,13.7082856 C20.8621308,13.1123051 20.4520957,12.5526008 19.9497475,12.0502525 C18.7580494,10.8585544 17.2435747,10.1863573 15.6877417,10.0336613 C15.4172492,9.60713196 15.0345505,9.21583511 14.54,8.86 C14.7266676,8.8333332 14.986665,8.82 15.32,8.82 Z M15.32,2.18 C15.7600022,2.18 16.1733314,2.2933322 16.56,2.52 C16.9466686,2.7466678 17.2533322,3.0533314 17.48,3.44 C17.7066678,3.8266686 17.82,4.2399978 17.82,4.68 C17.82,5.1200022 17.7066678,5.5333314 17.48,5.92 C17.2533322,6.3066686 16.9466686,6.6133322 16.56,6.84 C16.1733314,7.0666678 15.7600022,7.18 15.32,7.18 C14.8799978,7.18 14.4666686,7.0666678 14.08,6.84 C13.6933314,6.6133322 13.3866678,6.3066686 13.16,5.92 C12.9333322,5.5333314 12.82,5.1200022 12.82,4.68 C12.82,4.2399978 12.9333322,3.8266686 13.16,3.44 C13.3866678,3.0533314 13.6933314,2.7466678 14.08,2.52 C14.4666686,2.2933322 14.8799978,2.18 15.32,2.18 Z"/>
    </svg>
    { title && <span style={visuallyHidden}>{title}</span>}
  </>
);

Groupremove.displayName = "Groupremove"

Groupremove.defaultProps = {
  height: 24,
  title: null,
  width: 24,
};

Groupremove.propTypes = {
  height: PropTypes.number,
  title: PropTypes.string,
  width: PropTypes.number,
};

export default Groupremove;
